module.exports = __webpack_public_path__ + "static/media/particle-5.aed6c00d.svg";